import GoogleMapsApi from './GoogleMapsApiContainer';

export default GoogleMapsApi;



// WEBPACK FOOTER //
// ./src/components/GoogleMapsApi/index.js